import {
  DELETE_FIRMWARE_API,
  GET_FIRMWARE_API,
  IMPORT_FIRMWARE_API,
  SEARCH_FIRMWARES_API,
  UNOBSOLETE_FIRMWARES_API,
  UPDATE_FIRMWARE_API
} from '~/constants/APIs'
import {
  IFirmwareDeleteForm,
  IFirmwareDetails,
  IFirmwareSearchRequest,
  IFirmwareSearchResponse,
  IFirmwareUpdateForm
} from '~/models'
import axiosClient from './axiosClient'

export const firmwareApis = {
  searchFirmwares: (params: IFirmwareSearchRequest | null) =>
    axiosClient.get(SEARCH_FIRMWARES_API, {
      params
    }) as unknown as IFirmwareSearchResponse,

  updateFirmwares: (data: IFirmwareUpdateForm | null) =>
    axiosClient.put(UPDATE_FIRMWARE_API + data?.id, data),

  getFirmware: (id: string | undefined) =>
    axiosClient.get(GET_FIRMWARE_API + id) as unknown as IFirmwareDetails,

  importFirmware: (data: File[]) => {
    const formData = new FormData()
    data.forEach(item => formData.append('formFiles', item))
    return axiosClient.post(IMPORT_FIRMWARE_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  unObsoleteFirmwares: (data: { ids: number[] }) => {
    return axiosClient.post(UNOBSOLETE_FIRMWARES_API, data)
  },

  deleteFirmware: (data: IFirmwareDeleteForm) => {
    return axiosClient.delete(DELETE_FIRMWARE_API, { data })
  }
}
